import { render, staticRenderFns } from "./ParameterTitle.vue?vue&type=template&id=3db590ef&scoped=true&"
import script from "./ParameterTitle.vue?vue&type=script&lang=js&"
export * from "./ParameterTitle.vue?vue&type=script&lang=js&"
import style0 from "./ParameterTitle.vue?vue&type=style&index=0&id=3db590ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db590ef",
  null
  
)

export default component.exports